import { VenueFieldDisplayPreference } from 'common/api-types/director';

import { useTenantConfigQuery } from './useTenantConfigQuery';

type VenueField = NonNullable<VenueFieldDisplayPreference['primary']>;

const DEFAULT_VENUE_FIELD: VenueField = 'code';

const isVenueField = (value: VenueField | undefined) => value === 'name' || value === 'code';

export const useTenantDisplayConfig = (countryCode?: string) => {
  const { data: config } = useTenantConfigQuery(countryCode);

  const fields = config?.displayConfig?.fields;

  return {
    primaryVenueField: isVenueField(fields?.venue?.primary)
      ? fields.venue.primary
      : DEFAULT_VENUE_FIELD,
    secondaryVenueField: isVenueField(fields?.venue?.secondary)
      ? fields.venue.secondary
      : DEFAULT_VENUE_FIELD,
  };
};
